var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"auth-form-fade","mode":"out-in"}},[_c('KeepAlive',[_c(_vm.currentStep,{tag:"component",attrs:{"phoneNumber":_vm.phoneNumber},on:{"fillPhoneNumber":_vm.fillPhoneNumber}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }